import { TyTimelineItemProps } from './TyTimelineItem';
import { TyTimelineItemContentCard } from './TyTimelineItemContentCard';
import { TyTimelineItemContentProfile } from './TyTimelineItemContentProfile';

export const TyTimelineItemContent = (
  tyTimelineItemProps: TyTimelineItemProps
) => {
  return (
    <div className="flex flex-row gap-10">
      <TyTimelineItemContentProfile
        {...tyTimelineItemProps}
      />
      <TyTimelineItemContentCard
        {...tyTimelineItemProps}
      />
    </div>
  );
};
